import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { App } from './App.tsx'
import './index.css'
import "./firebase/firebaseConfig.ts";

const router = createBrowserRouter([
  {
    path: "/*",
    element: <App />,
  },
], {
  future: {
    v7_relativeSplatPath: true
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
) 
